import { defineNuxtPlugin } from "#app";
import { refreshNuxtData, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin((_nuxtApp) => {
  const options = useRuntimeConfig().public.prismic;
  if (options.preview) {
    window.addEventListener("prismicPreviewUpdate", (event) => {
      event.preventDefault();
      refreshNuxtData();
    });
  }
});
